<template>
    <div class="base-container">

  <div class="events-container">
   <v-card class="pa-3  ma-3 flex d-flex flex-column event-container" max-width="1200px" min-width="1200px" elevation="5">
                <div class="event-text">Events</div>
                <div class="event-table">
                  <v-simple-table fixed-header>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Resource group</th>
                          <th class="text-left">Message</th>
                          <th class="text-left">Event type</th>
                          <th class="text-left">Timestep</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="table-row" v-for="(item, index) in getEvents()" :key="index">
                          <td>{{ item.groupName }}</td>
                          <td>{{ eventToText(item) }}</td>
                          <td>{{ item.type }}</td>
                          <td>{{ $store.getters.hourToString(item.hour) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-card>
  </div>
    </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'Events',
  components: {
    
  },
  methods: {
    eventToText(event){
      if(event.type == "assignTask"){
        return "Assigned to task " + event.taskID + " of project index " + event.projectIndex;
      }
      if(event.type == "startHire"){
        return "Started hiring a resource";
      }
      if(event.type == "startFire"){
        return  "Started firing a resource";
      }
      if(event.type == "cancelFire"){
        return "Cancelled firing a resource";
      }
      if(event.type == "cancelHire"){
        return "Cancelled hiring a resource";
      }
      if(event.type == "finishFire"){
        return "Finished firing a resource";
      }
      if(event.type == "finishHire"){
        return "Finished hiring a resource";
      }
      if(event.type == "startTrain"){
        return "Started training for resource " + event.alternateGroupName;
      }
      if(event.type == "finishTrain"){
        return "Finished training for resource " + event.alternateGroupName;
      }
    },
    

    getEvents() {
      if(this.$store.state.simulator == null)
        return [];
      return this.$store.state.simulator.passedEvents.filter(e => e.type != "assignTask");
    },
  }
}
</script>

<style scoped>
.page-container{


  overflow: auto;
  min-width: 1000px;

}

.event-container{
  position: absolute;
}

.base-container{
  width: 100%;
    display: flex;
  justify-content: center;
}
.events-container{
  width: 1260px;
  overflow: auto;
}
.event-text {
  width: 100%;
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  margin-top: -10px;
  color: #373737;
}

.event-table {
  width: 100%;
  height: 100%;
  font-size: 3em;
}


.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
   font-size: 25px !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
     font-size: 20px !important;

}
</style>